

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import { logDevError } from "@/utils/devLogger";
import auth from "./auth";
import router from "./router";

auth
  .init()
  .then(() => {
    createApp(App).use(router).mount("#app");
  })
  .catch((error) => {
    logDevError("Auth initialisation failed", error);
  });
